import moment from 'moment';
import { parseToPhoneNumberObject } from '../utils/parsePhone';

const ACTIVE_RESERVATION_HOUR_DURATION = 3;

export function arrayToDictionary(value, key) {
  return value.reduce((acc, obj) => (
    {
      ...acc,
      [obj[key]]: obj,
    }
  ), {});
}

export function dictionaryToArray(dictionary) {
  return Object.keys(dictionary);
}

export function get(source, key) {
  let value;

  key.split('.')
    .forEach((val, i) => {
      value = (i === 0) ? source[val] : value[val];
    });

  return value;
}

export function getFirstArrayElement(array) {
  if (Array.isArray(array)) {
    return array[0];
  }
  return null;
}

export function getFromSource(source, key, value) {
  if (key in source) {
    if (value in source[key]) {
      return source[key][value];
    }
    return {};
  }

  return {};
}

export function getWhyWeLikeIt(data) {
  const whyWeLikeIt = data.find((content) => content.name === 'why_we_like_it');
  if (whyWeLikeIt && whyWeLikeIt.body) {
    return {
      attribution: whyWeLikeIt.attribution,
      body: whyWeLikeIt.body,
    };
  }
  return null;
}

export function formatPhone(value) {
  // The object return format for this function is weird. It's consistent with the old
  // parsePhoneGoogle behavior (and the subfield that formatPhone would extract from it)
  // that we have since deleted in favor of going through libphonenumber-js for everything.

  const phoneNumber = parseToPhoneNumberObject(value);

  return phoneNumber
    ? {
      phoneLabel: phoneNumber.formatInternational(),
      phoneUrl: phoneNumber.format('E.164'),
    }
    : {
      // Didn't parse; return something kinda nonsensical but that at least has a
      // reasonable shape.
      phoneLabel: value ?? '',
      phoneUrl: value ?? '',
    };
}

export function isUSLocation(value) {
  return value?.toLowerCase() === 'united states';
}

export function pastOrFuture(data) {
  if (moment.utc(data).add(ACTIVE_RESERVATION_HOUR_DURATION, 'hours').isBefore(moment())) {
    return 'past';
  }
  return 'future';
}

export function priceRange(data) {
  let range = '';
  for (let i = 0; i < data; i += 1) {
    range += '$';
  }
  return range;
}

export function rating(data) {
  if (data) {
    return data;
  }
  return 5;
}

export function reservationIsNow(data) {
  const now = moment.utc();
  if (moment.utc(data).add(ACTIVE_RESERVATION_HOUR_DURATION, 'hours').isAfter(now) && moment.utc(data).isBefore(now)) {
    return true;
  }
  return false;
}
